import Service from '@ember/service';

import { getOwner } from '@ember/owner';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { decorateClass, isDecoratorArgs } from 'decorator-setup';

/**
 * @decorator
 */
export function scrollRoot(id) {
  const isFactory = !isDecoratorArgs(...arguments);
  if (!isFactory) {
    id = null;
  }
  function classDecorator(Target) {
    if (!Route.prototype.isPrototypeOf(Target.prototype)) {
      throw new Error(
        '@scrollRoot decorator should be applied to an Ember Route derived class',
      );
    }
    return decorateClass(class ScrollRootDecoratedRoute extends Target {
      activate(...args) {
        super.activate(...args);
        const owner = getOwner(this);
        owner.lookup('service:scroll-root').scrollTo(id);
      }
    });
  }
  return isFactory ? classDecorator : classDecorator(...arguments);
}

export default class ScrollRootService extends Service {
  @service ssr;

  setElement(el) {
    this.el = el;
  }

  scrollTo(id) {
    if (this.ssr.isSsr) {
      return;
    }
    let el = id ? document.getElementById(id) : this.el;
    if (el === undefined) {
      window.scrollTo(0, 0);
    } else if (el && this.el.scrollIntoView) {
      this.el.scrollIntoView();
    }
  }
}
